import { useEffect, useState } from "react";

import UnknownSwitch from "./UnknownSwitch";
import "./VocaCardFront.css";

// 뜻 한 줄 "[동] 보다" 의 품사 칸을 떼어 낸다. 대괄호가 없으면 품사 없이 뜻만 준다.
export const splitPartOfSpeech = (line) => {
  const match = line.match(/^\s*\[(.*?)\]\s*(.*)$/);
  return match ? { partOfSpeech: match[1], meaning: match[2] } : { partOfSpeech: "", meaning: line };
};

export const VocaMeaningLine = ({ line }) => {
  const { partOfSpeech, meaning } = splitPartOfSpeech(line);
  return (
    <div className="voca-meaning">
      {partOfSpeech && <span className="voca-meaning__part">{partOfSpeech}</span>}
      <span>{meaning}</span>
    </div>
  );
};

// 이 길이부터는 폰 한 줄에 안 들어가 글자를 줄인다(뒷면 LONG_WORD_LENGTH 와 같은 값).
const LONG_WORD_LENGTH = 10;

const VocaCardFront = ({ currentPage, currentIndex, clickSwitch, onSpeak }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    if (currentIndex === 0) {
      setShowTooltip(true);
      const timer = setTimeout(() => setShowTooltip(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [currentIndex]);

  return (
    // 뒷면과 같은 칸에 포갠다(VocaCardPage 가 grid). 안쪽 스위치의 기준이기도 하므로 relative 를 유지한다.
    <div className="voca-card-front">
      <div className="voca-card-front__card">
        <div className="voca-card-front__head">
          <div
            className={`voca-card-front__word${currentPage.word.length >= LONG_WORD_LENGTH ? " voca-card-front__word--long" : ""}`}
            lang="en"
          >
            {currentPage.word}
          </div>
          <div className="voca-card-front__sound">
            {currentPage.pron && <span className="voca-card-front__pron">{currentPage.pron}</span>}
            {onSpeak && (
              <button
                type="button"
                className="voca-card-front__speak"
                aria-label="다시 듣기"
                onClick={(event) => {
                  event.stopPropagation();
                  onSpeak();
                }}
              >
                <svg viewBox="0 0 24 24" width="1em" height="1em" aria-hidden="true">
                  <path d="M4 9.5h3.2L12 5.6v12.8l-4.8-3.9H4z" fill="currentColor" />
                  <path d="M15.5 8.6a4.6 4.6 0 0 1 0 6.8M18 6.2a8 8 0 0 1 0 11.6" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" />
                </svg>
              </button>
            )}
          </div>
        </div>
        <div className="voca-card-front__meaning">
          {currentPage.kor.split("\n").map((line, index) => (
            <VocaMeaningLine key={index} line={line} />
          ))}
        </div>
      </div>
      <div
        className="voca-card-front__switch"
        // iOS 는 backface-visibility 를 absolute 자식에게 물려주지 않고, 스위치가 따로 합성되면
        // 부모의 뒤집힘도 따르지 않아 뒷면 왼쪽 위에 비쳤다(10/27 중앙고 단어 화면). 뒤집혀 있는 동안은 감춘다.
        style={{ visibility: currentPage.isOpened ? "hidden" : "visible" }}
        onClick={(event) => event.stopPropagation()}
      >
        {/* [단어장 v5] 모바일: 툴팁이 스크롤 따라다니는 버그 → 숨김. PC만 표시(CSS) */}
        <div className={`voca-card-front__tooltip${showTooltip ? " is-shown" : ""}`}>
          모르는 단어로 설정하면, 모아서 보여줘요!
        </div>
        <UnknownSwitch key={"switch_" + currentPage.word} initChecked={currentPage.isUnknown} onChange={clickSwitch} />
      </div>
    </div>
  );
};

export default VocaCardFront;
